import React from 'react';
import { CardComponentProps } from './types';

/**
 * Card body component for use with the Card component
 */
export const CardBody: React.FC<CardComponentProps> = ({
  children,
  className = '',
}) => <div className={`p-4 flex-grow ${className}`}>{children}</div>;
